import React, { useEffect, useState, useContext } from "react";
import CommonToolbar from "./CommonToolbar";
import "../css/ActiveCapability.css"; // Assuming you have a CSS file for styling
import { Constants } from "../common/constants";
import { useCapabilitiesContext } from "../context/CapabilitiesContext";
import { TeamsFxContext, TCTeamsFxContext } from "@siemensplm/common_utils";
import { getSiteCapabilities } from "../common/commonFunctions";
import { capabilityType } from "../types/CommonTypes";

const ActiveCapability: React.FC = () => {
  const {
    activeCapability,
    siteCapabilitiesList,
    loadCapability,
    setSiteCapabilitiesList,
  } = useCapabilitiesContext();
  const [componentName, setComponentName] = useState<string | null>(null);
  const teamsContext = useContext(TeamsFxContext);
  const tcTeamsContext = useContext(TCTeamsFxContext);
  const [localSiteCapabilitiesList, setLocalSiteCapabilitiesList] = useState<
    capabilityType[]
  >([]);
  const [siteCapabilitiesLoaded, setSiteCapabilitiesLoaded] = useState(false);

  useEffect(() => {
    if (
      !activeCapability ||
      !activeCapability.capabilityDetails ||
      !activeCapability.capabilityDetails.tabComponent
    ) {
      return;
    }
    setComponentName(activeCapability.capabilityDetails.tabComponent);
  }, [activeCapability]);

  const onSelect = async (
    capabilityname: string,
    capabilityId: string,
    capabilityDomain: string
  ) => {
    if (await loadCapability(capabilityname, capabilityId, capabilityDomain)) {
      const value = {
        capabilityName: capabilityname,
        capabilityId: capabilityId,
        capabilityDomain: capabilityDomain,
      };
      const activeCapability = JSON.stringify(value);
      localStorage.setItem(Constants.activeCapability, activeCapability);
    }
  };

  // Fetch site capabilities on component mount
  useEffect(() => {
    // Only call if not already loaded
    if (
      !siteCapabilitiesLoaded &&
      Array.isArray(siteCapabilitiesList) &&
      siteCapabilitiesList.length === 0
    ) {
      const fetchCapabilities = async () => {
        const capabilities = await getSiteCapabilities(
          teamsContext,
          tcTeamsContext
        );
        if (!Array.isArray(capabilities) || capabilities.length === 0) {
          return;
        }
        const filteredCapabilities = capabilities.filter(
          (capability: capabilityType) =>
            capability.capabilityId !== Constants.copilotCapabilityId
        );
        setLocalSiteCapabilitiesList(filteredCapabilities);
        setSiteCapabilitiesList(filteredCapabilities);
        setSiteCapabilitiesLoaded(true);
      };
      fetchCapabilities();
    } else if (Array.isArray(siteCapabilitiesList)) {
      setLocalSiteCapabilitiesList(siteCapabilitiesList);
    }
  }, []);

  return (
    <div className="activeCapability">
      <CommonToolbar
        capabilitiesList={localSiteCapabilitiesList}
        activeCapability={activeCapability}
        onSelect={onSelect}
      />

      <div className="activeCapabilityContainer">
        {activeCapability &&
          componentName &&
          activeCapability?.componentsMap &&
          activeCapability?.componentsMap[componentName] &&
          React.createElement(activeCapability.componentsMap[componentName])}
      </div>
    </div>
  );
};

export default ActiveCapability;
